<style lang="less">
.tip-wrapper {
  position: absolute;
  right: 0px;
  padding: 20px 8px;
  background: #FFFF80;
  cursor: pointer;
  & a {
    color: #333 !important;
  }
}
</style>

<template>
  <div class="tip-wrapper" >
    <router-link to="/parentchild.html" target="_blank" >
      关于开展"整治亲子流量账号营销"专项行动的公告
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ResidentAnnouncement',
  props: {},
  data () {
    return {
      rownum: 8,
      screenWidth: document.body.clientWidth
    }
  },

  methods: {
    handlePlay (mid) {
      window.open('/player/?mid=' + mid + '&cid=' + this.channel_id)
      // this.$router.push('/play/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResidentAnnouncement.vue